module.exports = __webpack_public_path__ + "img/index-section6-friend2_a.684f105c.svg";